import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const tournamentRankingSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.TOURNAMENT_NAV}`,
        popover: {
            title: "Tournament Sections",
            description:
                "You're in Team Ranking. Switch to Overview for the full tournament picture, or Compare to put two individual players head-to-head.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TOURNAMENT_STAT_CATEGORY}`,
        popover: {
            title: "Stat Category",
            description:
                "Filter the table columns by category: Overview, Shooting, Passing, Puck Control, Faceoffs, Advanced, or Special Teams. " +
                "Each category reveals different per-game and per-tournament metrics for every team.",
            side: "bottom",
            align: "end",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TOURNAMENT_RANKING_TABLE}`,
        popover: {
            title: "Team Rankings Table",
            description:
                "All teams in the tournament ranked by the current category. Click any column header to sort — green values are top-ranked, red are bottom-ranked. " +
                "Vålerenga's row is highlighted so you can benchmark instantly against the rest of the league.",
            side: "top",
            align: "center",
        },
    },
];
